<template>
  <div class="row h-100" id="page-forgot-password">

    <div class="col-4 m-auto">
      <h2 class="text-center mb-5">{{ $t('pages.forgotPassword.requestForgottenPassword') }}</h2>

      <div class="form-group">
        <input class="form-control" id="email" v-model="form.email" type="email" :placeholder="$t('pages.forgotPassword.yourEmail')">
      </div>

      <div class="text-center mt-3 mb-3">
        <a class="m-auto" href="/">{{ $t('pages.forgotPassword.backLoginPage') }}</a>
      </div>

      <button class="btn btn-lg btn-block btn-primary" v-on:click="requestForgotPassword" :disabled="submitting">
        <b-spinner small v-if="submitting"></b-spinner>
        {{ submitting ? 'Envoi en cours...' : $t('pages.forgotPassword.sendRequestForgottenPassword') }}
      </button>
    </div>
  </div>
</template>

<script>
import ResetPasswordRequestService from '@/services/ResetPasswordRequestService'

export default {
  data() {
    return {
      submitting: false,
      form: {
        email: ''
      }
    }
  },
  created() {
    this.$store.dispatch('logout', false)
  },
  methods: {
    requestForgotPassword() {
      if (!this.form.email) {
        this.$bvToast.toast(this.$t('pages.forgotPassword.errorFillEmail'), {
          title: this.$t('common.error'),
          variant: 'danger',
          solid: true
        })
        return
      }

      // AD-68: garde anti-double-soumission (en plus du bouton désactivé).
      if (this.submitting) {
        return
      }
      this.submitting = true

      // AD-68: réponse uniforme (anti-énumération). L'envoi de l'e-mail est géré côté serveur
      // si le compte existe ; on affiche le même message dans tous les cas.
      ResetPasswordRequestService.checkUserByEmail({ email: this.form.email })
          .then(() => {
            this.$bvToast.toast(this.$t('pages.forgotPassword.passwordRenewal'), {
              title: this.$t('pages.forgotPassword.requestPasswordRenewal'),
              variant: 'success',
              solid: true
            })
          })
          .catch((error) => {
            // AD-68: on remonte le message renvoyé par le serveur (ex. 429 « Trop de tentatives,
            // réessayez plus tard. ») plutôt que le message technique d'axios
            // (« Request failed with status code 429 »).
            const message = error?.response?.data?.error
                || error?.response?.data?.message
                || 'Une erreur est survenue, réessayez plus tard.'
            this.$bvToast.toast(message, {
              title: this.$t('common.error'),
              variant: 'danger',
              solid: true
            })
          })
          .finally(() => {
            // On réactive le bouton (l'utilisateur reste sur la page).
            this.submitting = false
          })
    }
  },
  computed: {}
}
</script>
